import React from 'react';
import styled from 'styled-components';

import Footer from '../containers/Footer';

const Wrapper = styled.div`
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center ;
  margin: 0 36px;
  margin-top: 20px;
  padding-bottom: 100px;
`;

const TitleText = styled.h2`
  font-size: 20px;
  line-height: 24px;
  margin: 20px 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic1000};
`;

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const FAQ = () => (
  <Wrapper>
    <TitleText>FAQ</TitleText>
    <h1> ¿Qué es Prestix? </h1>
    <Text>Prestix es una fintech que promueve la inclusión financiera en la Argentina. Ofrece préstamos inclusivos y 100% digitales a través del celular. Prestix responde a la necesidad de millones de argentinos que buscan acceder a servicios financieros de calidad de manera ágil, segura y desde donde quiera que estén. La tecnología de Prestix llegó para ampliar el acceso al crédito brindando una solución a medida, en menos de 24hs.</Text>

<h3> ¿Cuáles son los requisitos para solicitar un préstamo online? </h3>
<Text>1. Ser mayor de 21 años de edad. <br />
2. Estar radicado en Argentina con DNI Argentino.<br />
3. Tener un ingreso mensual demostrable.<br />
4. Ser titular de una cuenta bancaria, tener el CBU y la tarjeta de débito a mano.<br />
5. Completar la solicitud validando tu identidad con una selfie y foto a tu DNI.<br />
6. Por último, te vamos a pedir que tengas un teléfono celular activo y un mail particular.<br />
7. No tener antecedentes negativos en otras entidades bancarias.</Text>
<h3> ¿Qué necesito para pedir un préstamo online? </h3>
<Text>Necesitás tener conexión a internet, tu DNI y enviar tu solicitud de préstamo.
</Text>
<h3> ¿Es difícil solicitar un préstamo? </h3>
<Text>El proceso de solicitud es muy rápido y fácil. Completá la solicitud con tus datos en 5 minutos, te sacás una selfie y foto a tu DNI, evaluamos tu solicitud y te respondemos en el transcurso del día.
</Text>
<h3> ¿Cuánto prestan? ¿Cuántas cuotas mensuales dan para devolverlo? </h3>
<Text>El monto mínimo es de $20.000 y el máximo es de $350.000. Lo podés devolver en 3 a 36 meses, vos podés elegir.
</Text>
<h3> ¿Cuánto tardan en responderme? </h3>
<Text>¡Te respondemos en el día! Y si nos pediste un fin de semana te respondemos el lunes.
</Text>
<h3> ¿En cuanto tiempo lo acreditan? </h3>
<Text>El monto aprobado se te acreditará dentro del plazo de 24hs hábiles.


</Text>
 <Footer />
  </Wrapper>
);

export default FAQ;
